/** Whether the page has a service worker to talk to. */
export enum ServiceWorkerPresence {
  /** A worker is active, or one is installing or waiting and will be. */
  present = 'present',
  /** No registration, or one without any worker: the worker disappeared (unregistered, site data cleared). */
  missing = 'missing',
}
